module.exports = __webpack_public_path__ + "img/430x590px.c8828e13.png";